<template>
    <div id="all-referral-feed-modal" class="modal fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                    <h4 class="modal-title">REFERRAL FEED</h4>
                    <div class="actions pull-right">
                        <a class="btn btn-circle btn-icon-only btn-default" :href="exportUrl">
                            <i class="icon-cloud-download"></i>
                        </a>
                    </div>
                </div>
                <div class="modal-body">
                    <form>
                        <h5 v-if="!loading.index">Select Date Range</h5>
                        <date-picker
                            v-if="!loading.index"
                            v-model="range"
                            placeholder="Select Date Range"
                            lang="en"
                            range-separator="-"
                            :format="user.date_format"
                            :value-type="'YYYY-MM-DD'"
                            :range="true"
                            :confirm="false"
                            prefix-class="xmx"
                            @change="changeDate"
                        />

                        <br><br>
                        <div class="portlet-body">
                            <vue-spinner v-if="loading.index"></vue-spinner>
                            <div v-else>
                                <div  v-for="item in index.referrals">

                                    <template v-if="item.status === 'enrolled'">Referral completed for:
                                        <router-link
                                                :to="{ name: 'Dashboard Participant', params: { id: item.participant_id } }" tag="a">{{ item.participant_name }}</router-link> on {{ item.created_at.date | formatDate }}</template>
                                    <template v-else-if="item.status === 'not_enrolled'">Referral completed for:
                                        <router-link :to="{ name: 'Referral Dashboard', params: { id: item.participant_id } }" tag="a">
                                            {{ item.participant_name }}</router-link> on {{ item.created_at.date | formatDate }}</template>
                                    <template v-else>Referral received for:
                                        <router-link :to="{ name: 'Referral Dashboard', params: { id: item.participant_id } }" tag="a">
                                            {{ item.participant_name }}</router-link> on {{ item.created_at.date | formatDate }}</template>

                                    <hr>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <pagination
                                :page-count="index.pages"
                                :page-range="1"
                                :margin-pages="1"
                                :click-handler="changePage"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination pagination-sm'">
                        </pagination>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP, ERROR, URL} from '@/http-common';
    import {mapGetters, mapActions} from 'vuex';
    import Pagination from '@/components/Pagination.vue'
    import Spinner from '@/components/Spinner'
    import DatePicker from 'vue2-datepicker'

    export default {
        data() {
            return {
                range: ['',''],
                page: 1
            }
        },
        components:{
            Pagination,
            DatePicker,
            'vue-spinner': Spinner
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                index: 'referrals/getIndex',
                loading: 'referrals/getLoading',
            }),
            exportUrl() {
                let from = this.range[0];
                let to = this.range[1];
                return URL+'/referrals/export-feed-as-csv?from='+from+'&to='+to+'&token=' + localStorage.getItem('id_token');
            }
        },
        mounted() {
            this.fetchIndex({from: this.range[0], to: this.range[1], page: this.page});
            $('#all-referral-feed-modal').modal('show');
            $('#all-referral-feed-modal').on('hidden.bs.modal', () => {
                this.$emit('hide');
            });
        },
        methods: {
            ...mapActions({
                fetchIndex: 'referrals/fetchIndex',
                exportCsv: 'referrals/exportFeedAsCsv'
            }),
            changeDate() {
                this.page = 1;
                this.fetchIndex({from: this.range[0], to: this.range[1], page: this.page});
            },
            changePage(page) {
                this.page = page;
                this.fetchIndex({from: this.range[0], to: this.range[1], page: this.page});
            },
        },

        watch: {

        },
    }
</script>

<style scoped lang="scss">
    #all-referral-feed-modal {
        .modal-dialog {
            min-width: 450px;
        }
        .portlet-body {
            height: auto;
        }
        hr {
            margin: 10px 0;
        }
    }

</style>



// WEBPACK FOOTER //
// ReferralShowAllModal.vue?05e4aa6a